module.exports = __webpack_public_path__ + "img/thumb-sarahl-off.9c728d94.jpg";